import { DefaultState } from 'store/types';
import { Filters } from 'store/types';

export const REQUESTS_BY_CLIENT_REQUEST = 'REQUESTS_BY_CLIENT_REQUEST';
export const REQUESTS_BY_CLIENT_SUCCESS = 'REQUESTS_BY_CLIENT_SUCCESS';
export const REQUESTS_BY_CLIENT_FAILURE = 'REQUESTS_BY_CLIENT_FAILURE';

export interface RequestsByClientParams {
  filters: Filters;
  paging: {
    page: number;
    pageSize: number;
  };
  sorting: {
    id: string;
    order: string;
  };
}

export interface RequestsByClientRow {
  corporateClientName: string;
  allActive: number;
  open: number;
  pending: number;
  draft: number;
  completed: number;
  canceled: number;
  flagged: number;
}

export interface RequestsByClientData {
  rows: RequestsByClientRow[];
  totalCount: number;
}

export type RequestsByClientState = DefaultState & {
  contents?: RequestsByClientData;
}

interface RequestsByClientDataRequest {
  type: typeof REQUESTS_BY_CLIENT_REQUEST;
}

interface RequestsByClientDataSuccess {
  type: typeof REQUESTS_BY_CLIENT_SUCCESS,
  contents: RequestsByClientData;
}

interface RequestsByClientDataFailure {
  type: typeof REQUESTS_BY_CLIENT_FAILURE;
}

export type RequestsByClientActionTypes = RequestsByClientDataRequest | RequestsByClientDataSuccess | RequestsByClientDataFailure;